<template>
        <div :id="this.$route.name">
            <card>
                <template v-slot:header>
                    <h3>{{CustomerName}}</h3>
                    <hr>
                </template>
                <template v-slot:content>
                    <div class="row">
                        <div class="col-md-4 col-12 text-center">
                            جمع کل خرید  
                            <h4 class="mt-2">{{$Comma3ragham(Detail.TotallAmount)}}</h4>
                        </div>
                        <div class="col-md-4 col-12 text-center">
                            جمع پرداختی
                            <h4 class="mt-2">{{$Comma3ragham(Detail.DepositAmount)}}</h4>
                        </div>
                        <div class="col-md-4 col-12 text-center">
                            الباقی بدهی
                            <h4 class="mt-2 " :class="Detail.Remember>=0?'text-warning':'text-success'">{{$Comma3ragham(Detail.Remember)}}</h4>
                        </div>
                    </div>
                </template>
            </card>


            <card v-if="!DepositForUnAmount" >
                <template v-slot:header>
                <h5 class="d-inline"><i class="fad fa-arrow-right text-secondary ml-2 Pointer" @click="BakToDetailCustomer"></i></h5>
                <h4 class="d-inline">ثـبت فیش واریز / ثـبت چک</h4>
                <hr>    
                </template>
                <template v-slot:content>
                    <div id="DepositInCustomer" autocomplete="off">
                        <div class="row">
                            <div class="col-md-3">
                                <small id="LblTblCostomer">مربوط به مشتری</small>
                                <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResultTblCostomer"
                                    :rownumintable="3" :defaultvalue="DataAxios.TblCustomerId"
                                    :action="'TblCrmCombo/GetCostomer'" :method="'POST'" :idinput="'TblCostomer'"
                                    :keyItem="'TblCostomer'" :disabled="DataAxios.TblCustomerId" :ClassProps="'required'">
                                </SearchableCombo>
                            </div>
                            <div class="col-md-3">
                                <small id="LblTblCostomer"> انتخاب بانک </small>
                                <SearchableCombo :edit="false" :grp="29" :code="null" @ResultCombo="GetResultComboIdGrp29"
                                    :rownumintable="3" :defaultvalue="DataAxios.tblComboIdGrp29"
                                    :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'ComboIdGrp29'"
                                    :keyItem="'ComboIdGrp29'" :disabled="false" :ClassProps="'required'">
                                </SearchableCombo>
                            </div>
                            <div class="col-md-3">
                                <small id="LblTblCostomer" > انتخاب نوع واریزی </small>
                                <SearchableCombo :edit="false" :grp="40" :code="null" @ResultCombo="GetResultComboIdGrp40"
                                    :rownumintable="3" :defaultvalue="DataAxios.tblComboIdGrp40"
                                    :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'ComboIdGrp40'"
                                    :keyItem="'ComboIdGrp40'" :disabled="false" :ClassProps="'required'">
                                </SearchableCombo>
                            </div>
                            <div class="col-md-3 col-12">
                                <small id="LblTaskDate"> تاریخ </small>
                                <date-picker input-class="required form-control" color="dimgray" v-model="DataAxios.Date"  clearable :editable="true" 
                                    placeholder="تاریخ"></date-picker>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 col-12">
                                <small id="LblAmount">مبـلغ واریـزی </small>
                                <input dir="ltr" type="text" @keypress="$ValidNumber($event, 15);" @keyup="DataAxios.Amount = $PutCommatoInput_New($event);"  class="form-control required" id="txtAmount" v-model="DataAxios.Amount" tabindex="5" />
                            </div>
                            <div class="col-md-2 col-12">
                                <small id="LblTrackingCode">شماره پیگیری</small>
                                <input  type="text" class="form-control required" v-model="DataAxios.TrackingCode" />
                            </div>
                            <!-- <div class="col-md-2 col-12">
                                <small id="LblDocNumber">شماره سند</small>
                                <input  type="text" class="form-control " v-model="DataAxios.DocNumber"/>
                            </div> -->
                            <div class="col-md-7 col-12">
                                <small id="LblDes">توضیحات</small>
                            <textarea @keypress="$ValidPersian($event, 250)" rows="1" type="text" id="Des" class="form-control " v-model="DataAxios.Des" ></textarea>     
                            </div>
                        </div>
                        
                        
                    <hr>
                                <button @click.prevent="SaveDetaDetail" class="btn-success btn ">  ثبت اطلاعات واریزی</button>
                    </div>
                    
                <!-- <button class="btn btn-success mr-5" @click.prevent="SaveDeta();">ثبت اطلاعات</button>
                <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Cancel();">انصراف</button> -->
                </template>
            </card>
            <card v-if="DepositForUnAmount" >
                <template v-slot:header>
                    <h5 class="d-inline"><i class="fad fa-arrow-right text-secondary ml-2 Pointer" @click="BakToDetailCustomer"></i></h5>
                    <h4 class="d-inline text-danger">ثبت عودت مبـــلغ</h4>
                    <hr>    
                </template>
                <template v-slot:content>
                    <div id="DepositInCustomer" autocomplete="off">
                        <div class="row">
                            <div class="col-md-3">
                                <small id="LblTblCostomer">مربوط به مشتری</small>
                                <SearchableCombo :edit="false" :grp="0" :code="null" @ResultCombo="GetResultTblCostomer"
                                    :rownumintable="3" :defaultvalue="DataAxios.TblCustomerId"
                                    :action="'TblCrmCombo/GetCostomer'" :method="'POST'" :idinput="'TblCostomer'"
                                    :keyItem="'TblCostomer'" :disabled="DataAxios.TblCustomerId" :ClassProps="'required'">
                                </SearchableCombo>
                            </div>
                            <div class="col-md-3">
                                <small id="LblTblCostomer"> انتخاب بانک عودت شده</small>
                                <SearchableCombo :edit="false" :grp="29" :code="null" @ResultCombo="GetResultComboIdGrp29"
                                    :rownumintable="3" :defaultvalue="DataAxios.tblComboIdGrp29"
                                    :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'ComboIdGrp29'"
                                    :keyItem="'ComboIdGrp29'" :disabled="false" :ClassProps="'required'">
                                </SearchableCombo>
                            </div>
                            <div class="col-md-3">
                                <small id="LblTblCostomer" > انتخاب نوع عودت </small>
                                <SearchableCombo :edit="false" :grp="40" :code="null" @ResultCombo="GetResultComboIdGrp40"
                                    :rownumintable="3" :defaultvalue="DataAxios.tblComboIdGrp40"
                                    :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'ComboIdGrp40'"
                                    :keyItem="'ComboIdGrp40'" :disabled="false" :ClassProps="'required'">
                                </SearchableCombo>
                            </div>
                            <div class="col-md-3 col-12">
                                <small id="LblTaskDate"> تاریخ </small>
                                <date-picker input-class="required form-control" color="dimgray" v-model="DataAxios.Date"  clearable :editable="true" 
                                    placeholder="تاریخ"></date-picker>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 col-12">
                                <small id="LblAmount">مبـلغ عودت </small>

                                
                                <input dir="ltr" type="text" @keypress="$ValidNumber($event, 15);" @input="CheckAmountUnAmount($event)" @keyup="DataAxios.UnAmount = $PutCommatoInput_New($event);"  class="form-control InputText 3ragham required" id="txtAmount" v-model="DataAxios.UnAmount" tabindex="5" />
                            </div>
                            <div class="col-md-2 col-12">
                                <small id="LblTrackingCode">شماره پیگیری</small>
                                <input  type="text" class="form-control required" v-model="DataAxios.TrackingCode" />
                            </div>
                            <!-- <div class="col-md-2 col-12">
                                <small id="LblDocNumber">شماره سند</small>
                                <input  type="text" class="form-control " v-model="DataAxios.DocNumber"/>
                            </div> -->
                            <div class="col-md-7 col-12">
                                <small id="LblDes">توضیحات</small>
                            <textarea @keypress="$ValidPersian($event, 250)" rows="1" type="text" id="Des" class="form-control " v-model="DataAxios.Des" ></textarea>     
                            </div>
                        </div>
                        
                        
                    <hr>
                                <button @click.prevent="SaveDetaDetail" class="btn-warning btn ">  ثبت اطلاعات عودت</button>
                    </div>
                    
                <!-- <button class="btn btn-success mr-5" @click.prevent="SaveDeta();">ثبت اطلاعات</button>
                <button id="btnCancel" class="btn btn-warning m-2" @click.prevent="Cancel();">انصراف</button> -->
                </template>
            </card>

           

       
        </div>
</template>
<script>
import Card from '@/components/Card/Card.vue';
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import SearchableCombo from "@/components/Combo/SearchableCombo.vue";
import CardBox from '@/components/CardBox/CardBox.vue';
import Treeselect from '@riophae/vue-treeselect'

export default {
  components: { Card,datePicker: VuePersianDatetimePicker,SearchableCombo ,CardBox,Treeselect},
    data(){
        return{
            DataAxios: {},
            DataAxiosDetail: {},
            txtContract:'',
            step:1,
            DataAxiosPost: {
                ArryfildValue: {},
                Method: "post",
                Action: "",
                Token: this.$session.get("Token"),
                From: "Body",
            },
            listProduct:[],
            sumTotall:0,
             Rows:[],
            Column:[],
            DataAxoisCol:{
                ArryfildValue: {
                    SoftwareId: 2,
                    UserId: 1,
                    FormName: "frmDeposit",
                    ShowView: 0,
                    },
                Method: "post",
                Action: "ReadGridColumns",
            },
            DataAxios_Post: {
                Action: "Deposit/Index",
                Method: "Post",
                Token: this.$session.get("Token"),
                ArryfildValue: {}
            },
            Detail:{},
            CustomerName:"",
            TotallAmountProduct:0,
            normalizer(node) {
                    return {
                    id: node.id,
                    label: node.name,
                    }
                },
                multiple: true,
                clearable: false,
                searchable: true,
                disabled: false,
                openOnClick: true,
                openOnFocus: false,
                clearOnSelect: true,
                closeOnSelect: false,
                alwaysOpen: false,
                appendToBody: false,
                value: [],
                options: [],
                DataAxios_GetData: {
                ArryfildValue: {},
                Method: '',
                Action: '',
                Token: this.$session.get('Token'),
                },
                check:false,
                DepositForUnAmount:{}
        
        };
    },
    methods:{
        ItemSelected(node) {
            // console.log(node);
                this.value.push(node.id)
                this.listProduct.push(node)
                },
        ItemDeselect(node) {
        for (let index = 0; index < this.value.length; index++) {
            if (this.value[index] == node.id) {
            this.value.splice(index, 1)
            }
        }
        },
        openDetail(){
            if(this.DataAxios.TblCustomerId!=null){
                this.$store.state.renderComponentCombo = false;
                this.$nextTick(() => {
                this.$store.state.renderComponentCombo = true;
                            this.$bvModal.show('modal-Deposit');
            });
            }
            else{
                this.$mySweetDefault("عملیات ناموفق","اطلاعات مشتری را تکمیل تمایید","error",2500);
                return;
                }
            
        },
        Delete(id){
            for (let index = 0; index < this.listProduct.length; index++) {
                if (this.listProduct[index].Id == id) {
                    this.sumTotall=this.sumTotall-Number(this.listProduct[index].Amount.replace(/,/g, "").replace(/\./g, ""))
                    this.listProduct.splice(index,1);
                    return;
                }
        }
        },
        SaveDeta(){
            
        },
        Cancel(){
           this.$router.go(-1)
        },
        // AddDetail(){
        //     if (this.$ValidForm('DepositDetail')) {
        //         if(this.listProduct.length>0){
        //             if(Number(this.DataAxiosDetail.Amount.replace(/,/g, "").replace(/\./g, "")) <=  Number(this.TotallAmountProduct)){
        //                 this.sumTotall+=Number(this.DataAxiosDetail.Amount.replace(/,/g, "").replace(/\./g, "")) 
        //                 var findItem = false;  
        //                 if (Number(this.sumTotall)<=this.Detail.Remember) {
        //                     for (let index = 0; index < this.listProduct.length; index++) {
        //                         if (this.listProduct[index].TblCustomerProductId == this.DataAxiosDetail.TblCustomerProductId) {
        //                             findItem = true;
        //                         }
        //                     }
        //                     if (findItem == false) {
        //                         this.listProduct.push(JSON.parse(JSON.stringify(this.DataAxiosDetail)));
        //                         this.DataAxios.Amount=this.sumTotall
        //                         // this.$mySweetDefaultTost("عملیات موفق","آیتم مورد نظر شما به لیست اضافه گردید ","success",1000);
        //                         return;
        //                     }
        //                     else {
        //                         this.$mySweetDefault("عملیات ناموفق","آیتم مورد نظر شما در لیست وجود دارد","error",1500);
        //                         return;
        //                     }  
        //                 }
        //                 else{
        //                     this.$mySweetDefault("عملیات ناموفق","جمع مبالغ واریزی از مبلغ کل قرارداد بیشتر می باشد","error",2500);
        //                 }
        //             }
        //             else{
        //                 this.$mySweetDefault("عملیات ناموفق","جمع مبالغ از کل مبلغ واریزی بیشتر است","error",2500);
        //                 return;
        //             }

        //         }
        //         else{
        //             if(Number(this.DataAxiosDetail.Amount.replace(/,/g, "").replace(/\./g, ""))<= this.Detail.Remember && Number(this.DataAxiosDetail.Amount.replace(/,/g, "").replace(/\./g, "")) <=  Number(this.TotallAmountProduct) ){
        //                 this.sumTotall=Number(this.DataAxiosDetail.Amount.replace(/,/g, "").replace(/\./g, ""))
        //                 this.listProduct.push(JSON.parse(JSON.stringify(this.DataAxiosDetail)));
        //                 this.$mySweetDefaultTost("عملیات موفق","آیتم مورد نظر شما به لیست محصولات اضافه گردید ","success",1000);
        //                         this.DataAxios.Amount=this.$Comma3ragham(this.sumTotall)
        //                 return;
        //             }else{    
        //                 this.$mySweetDefault("عملیات ناموفق","مبلغ واریزی بیشتر از مبلغ قرارداد می باشد","error",2500);
        //                 return;
        //             }

        //         }
        //     }
            
        // },
        SaveDetaDetail(){
            if (this.$ValidForm('DepositInCustomer')){
                // if(Number(this.DataAxios.Amount.replace(/,/g, "").replace(/\./g, "")) <=  Number(this.Detail.Remember)){
                   this.DepositInfo?this.DataAxios['ParentId']=this.DepositInfo.Id:null;
                   
                    // واریز ریز
                    // const TblDepositDetail =[];

                    //     for (let index = 0; index < this.listProduct.length; index++) {
                    //         TblDepositDetail.push({
                    //         tblContractsId: this.listProduct[index].tblContractId,
                    //         tblCustomerProductId :this.listProduct[index].id ,
                    //         Amount:  this.DataAxios.Amount,
                    //         DateDeposit: this.DataAxios.Date,
                    //         FactorNumber : 100,
                    //         tblUserGrpIdInsert: this.$session.get("UserInfo").tblUserGrpId
                    //         });
                    //     }
                    //     this.DataAxios.TblDepositDetail=TblDepositDetail

                     this.DataAxiosPost.Action = this.$route.name;
            
                        this.DataAxiosPost.ArryfildValue=this.DataAxios;
                        this.$PostData(this.DataAxiosPost)
                                .then((data) => {
                                    if (data.status == "Ok") {
                                        this.step =2
                                         var DataAxiosDetail={
                                            Action:'Deposit/InsertDepositDetail',
                                            ArryfildValue:{tblDepositId:data.result.id},
                                            Method: "post",
                                            Token:this.$session.get("Token")
                                         };
                                         this.$PostData(DataAxiosDetail).then((resDetail)=>{
                                            if(resDetail.status="Ok"){
                                                this.$toasted.success('اطلاعات واریز با موفقیت ثبت شد', {
                                                action: {
                                                    text: 'بستن',
                                                    onClick: (e, toastObject) => {
                                                    toastObject.goAway(10000);
                                                    }
                                                }
                                            },);
                                        }
                                         })                                    
                                    }
                                    if (data.status=='Ok UnAmount') {
                                        this.$toasted.success('اطلاعات عودت با موفقیت ثبت شد', {
                                                duration: 2000,
                                            },);
                                    }
                                }).finally(()=>{
                                    this.$router.push({name:"DetailCustomer",params:{tblCustomerId:this.DataAxios.TblCustomerId,activeTab:10}})
                                })
                // }
                // else{
                //         this.$mySweetDefault("عملیات ناموفق","جمع مبلغ واریزی بیشتر بدهی مشتری می باشد","error",2500);
                //         return;
                //     }
           
            }
        },
        CancelDetail(){
           this.step =1 
        },
        GetResultTblCostomer(data) {
                this.DataAxios.TblCustomerId = data.id    
                this.CustomerName=data.name
                // console.log(this.CustomerName);
                this.CalcBedehiCustomer(this.DataAxios.TblCustomerId);          
        },
        GetResultComboIdGrp29(data){
                this.DataAxios.tblComboIdGrp29=data.id
        },
        GetResultComboIdGrp40(data){
            this.DataAxios.tblComboIdGrp40=data.id
        },
        GetCustomerProduct(data){
                    this.DataAxiosDetail.TblCustomerProductId=data.id
                    if(data.element!=null){
                        this.DataAxiosDetail.TblContractId=data.element.tblContractId            
                        this.TotallAmountProduct=data.element.totallAmount            
                    }
        },
        CalcBedehiCustomer(TblCustomerId){
            let DataAxios_GetRemember={
                ArryfildValue: {},
                Method: "post",
                Action: "Deposit/GetRemember",
                Token: this.$session.get("Token")
            }
            DataAxios_GetRemember.ArryfildValue={tblCustomerId:TblCustomerId}
            this.$PostData(DataAxios_GetRemember).then(data=>{
                this.Detail=data[0]
                // console.log(data[0]);
                //
            }).finally(()=>{

            })
        },
        BakToDetailCustomer(){
            this.$router.push({name:"DetailCustomer",params:{tblCustomerId:this.DataAxios.TblCustomerId,activeTab:10}})
        },


        CheckAmountUnAmount(e){
            
            console.log(Number(e.target.value.replace(/,/g, '').replace(/\./g, ''))>this.DepositForUnAmount.Amount);
            if(Number(this.DataAxios.UnAmount.replace(/,/g, '').replace(/\./g, ''))>this.DepositForUnAmount.Amount){
                this.$toasted.error('مبلغ درخواستی برا عودت بیشتر از مبلغ واریزی میباشد ، مبلغ عودت شما توسط سامانه ویرایش گردید',{duration: 3000})
               this.DataAxios.UnAmount=this.DepositForUnAmount.Amount
            }
        }
    },
    mounted(){
        this.step=1
         this.DataAxios.TblUserGrpIdInsert=this.$session.get("UserInfo").tblUserGrpId
    },
    beforeMount(){
        this.$GetColumns(this.DataAxoisCol, true)
            .then((data) => {
                this.Column=data;

            })
            .finally(()=>{
                this.$store.state.renderComponentGrid = false;
                this.$nextTick(() => {
                this.$store.state.renderComponentGrid = true;
                });
            });
    },
    props:['TblCustomerId','DepositInfo'],
    created(){
        if (this.TblCustomerId) {
            this.DataAxios.TblCustomerId=this.TblCustomerId
            this.CalcBedehiCustomer(this.TblCustomerId)
        }
        this.DepositForUnAmount=this.DepositInfo
        
    }
}
</script>
<style scoped>

</style>